/* Landing gift card: importo, messaggio con firma, destinatario, data di invio, anteprima e-mail, aggiunta al carrello.
   I campi inviati sono quelli nativi Shopify (vedi sections/gift-card-landing.liquid). */
if (!customElements.get('gift-card-builder')) {
  customElements.define(
    'gift-card-builder',
    class GiftCardBuilder extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.section = this.closest('.shopify-section') || document;
        this.maxChars = parseInt(this.dataset.maxChars, 10) || 200;
        this.el = {
          to: this.querySelector('[data-gc-to]'),
          from: this.querySelector('[data-gc-from]'),
          message: this.querySelector('[data-gc-message]'),
          count: this.querySelector('[data-gc-count]'),
          email: this.querySelector('[data-gc-email]'),
          emailLabel: this.querySelector('[data-gc-email-label]'),
          date: this.querySelector('[data-gc-date]'),
          dateWrap: this.querySelector('[data-gc-date-wrap]'),
          terms: this.querySelector('[data-gc-terms]'),
          submit: this.querySelector('[data-gc-submit]'),
          submitLabel: this.querySelector('[data-gc-submit-label]'),
          offset: this.querySelector('[data-gc-offset]'),
          pvTo: this.querySelector('[data-pv-to]'),
          pvSubject: this.querySelector('[data-pv-subject]'),
          pvTitle: this.querySelector('[data-pv-title]'),
          pvMsg: this.querySelector('[data-pv-msg]'),
          pvFrom: this.querySelector('[data-pv-from]'),
          pvSend: this.querySelector('[data-pv-send]'),
        };
        this.suggestions = [...this.querySelectorAll('[data-gc-suggestion]')];
        this.setDateBounds();
        if (this.el.offset) this.el.offset.value = new Date().getTimezoneOffset().toString();

        this.addEventListener('input', () => this.render());
        this.addEventListener('change', () => this.render());
        this.suggestions.forEach((b) =>
          b.addEventListener('click', () => {
            this.el.message.value = b.dataset.gcSuggestion.slice(0, this.messageRoom());
            this.render();
            this.el.message.focus();
          })
        );
        this.form.addEventListener('submit', (e) => this.onSubmit(e));

        const dialog = this.section.querySelector('dialog.gc-dialog');
        const opener = this.querySelector('[data-gc-terms-open]');
        if (dialog && opener) {
          opener.addEventListener('click', () => dialog.showModal());
          dialog.querySelector('[data-gc-terms-close]')?.addEventListener('click', () => dialog.close());
          dialog.addEventListener('click', (e) => {
            if (e.target === dialog) dialog.close();
          });
          dialog.addEventListener('close', () => opener.focus());
        }
        this.render();
      }

      value(selector) {
        const c = this.querySelector(`${selector}:checked`);
        return c ? c.value : '';
      }

      isoDate(d) {
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      }

      setDateBounds() {
        if (!this.el.date) return;
        const today = new Date();
        const max = new Date();
        max.setDate(max.getDate() + 90);
        this.el.date.min = this.isoDate(today);
        this.el.date.max = this.isoDate(max);
      }

      /* Spazio disponibile per il messaggio: 200 caratteri meno la firma ("\n\n" + nome). */
      messageRoom() {
        const from = this.el.from.value.trim();
        return this.maxChars - (from ? from.length + 2 : 0);
      }

      composedMessage() {
        const msg = this.el.message.value.trim();
        const from = this.el.from.value.trim();
        if (!from) return msg;
        return msg ? `${msg}\n\n${from}` : from;
      }

      formatDate(iso) {
        if (!iso) return '';
        const [y, m, d] = iso.split('-').map(Number);
        try {
          return new Intl.DateTimeFormat(document.documentElement.lang || undefined, { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(y, m - 1, d));
        } catch (e) {
          return iso;
        }
      }

      render() {
        const amountInput = this.querySelector('input[name="id"]:checked');
        const amount = amountInput ? amountInput.dataset.amount : '';
        const price = amountInput ? amountInput.dataset.price : '';
        this.section.querySelectorAll('[data-gc-card-amount]').forEach((el) => (el.textContent = amount));
        this.el.submitLabel.textContent = `${this.dataset.addLabel} · ${price}`;

        const room = this.messageRoom();
        this.el.message.maxLength = Math.max(room, 0);
        if (this.el.message.value.length > room) this.el.message.value = this.el.message.value.slice(0, Math.max(room, 0));
        this.el.count.textContent = this.dataset.charsLeft.replace('[count]', Math.max(room - this.el.message.value.length, 0));
        this.suggestions.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.gcSuggestion === this.el.message.value)));

        const dest = this.value('[data-gc-dest]');
        this.el.emailLabel.textContent = dest === 'me' ? this.dataset.labelEmailMe : this.dataset.labelEmailThem;
        this.el.email.autocomplete = dest === 'me' ? 'email' : 'off';

        const when = this.value('[data-gc-when]');
        this.el.dateWrap.hidden = when !== 'date';
        this.el.date.disabled = when !== 'date';

        const to = this.el.to.value.trim();
        const from = this.el.from.value.trim();
        const email = this.el.email.value.trim();
        this.el.pvTo.textContent = email || (dest === 'me' ? this.dataset.phMe : this.dataset.phThem);
        // oggetto fisso: il nome di chi regala non è un campo Shopify, nel modello della mail non può andare nell'oggetto
        this.el.pvSubject.textContent = this.dataset.subjectNosender;
        this.el.pvTitle.textContent = to ? this.dataset.titleName.replace('[name]', to) : this.dataset.titleNoname;
        const msg = this.el.message.value.trim();
        this.el.pvMsg.hidden = !msg;
        this.el.pvMsg.textContent = msg ? `“${msg}”` : '';
        this.el.pvFrom.hidden = !from;
        this.el.pvFrom.textContent = from;
        this.el.pvSend.textContent =
          when === 'date' && this.el.date.value ? this.dataset.sendDate.replace('[date]', this.formatDate(this.el.date.value)) : this.dataset.sendNow;
      }

      showError(key, text, field) {
        const box = this.querySelector(`[data-gc-error="${key}"]`);
        if (!box) return;
        box.textContent = text || '';
        box.hidden = !text;
        if (field) field.setAttribute('aria-invalid', text ? 'true' : 'false');
      }

      validate() {
        let first = null;
        const email = this.el.email;
        const emailOk = email.value.trim() !== '' && email.checkValidity();
        this.showError('email', emailOk ? '' : this.dataset.errorEmail, email);
        if (!emailOk) first = first || email;

        if (!this.el.date.disabled) {
          const v = this.el.date.value;
          const dateOk = v && v >= this.el.date.min && v <= this.el.date.max;
          this.showError('send_on', dateOk ? '' : this.dataset.errorDate, this.el.date);
          if (!dateOk) first = first || this.el.date;
        } else {
          this.showError('send_on', '', this.el.date);
        }

        const termsOk = this.el.terms.checked;
        this.showError('terms', termsOk ? '' : this.dataset.errorTerms, this.el.terms);
        if (!termsOk) first = first || this.el.terms;

        this.showError('form', '');
        if (first) first.focus();
        return !first;
      }

      async onSubmit(e) {
        e.preventDefault();
        if (this.el.submit.getAttribute('aria-busy') === 'true') return;
        if (!this.validate()) return;

        const data = new FormData(this.form);
        data.set('properties[Message]', this.composedMessage());
        if (!data.get('properties[Recipient name]')) data.delete('properties[Recipient name]');
        if (!data.get('properties[Message]')) data.delete('properties[Message]');
        // Prova dell'accettazione nell'ordine (proprietà con "_": nascosta al cliente, visibile in admin).
        // Termini = Termini e condizioni del servizio del sito (/policies/terms-of-service), decisione Alessandro 08/10/2026.
        data.set('properties[_Termini]', 'Accettati i Termini e condizioni del servizio');

        this.el.submit.setAttribute('aria-busy', 'true');
        this.el.submit.querySelector('.loading__spinner')?.classList.remove('hidden');
        try {
          const res = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: data,
          });
          const json = await res.json();
          if (!res.ok || json.status) {
            const errors = json.errors && typeof json.errors === 'object' ? json.errors : null;
            if (errors && errors.email) this.showError('email', this.dataset.errorEmail, this.el.email);
            if (errors && errors.send_on) this.showError('send_on', this.dataset.errorDate, this.el.date);
            // Shopify su errori dei campi destinatario manda description/errors come oggetto: si mostra il messaggio del campo, non l'oggetto
            const fieldErrors = errors && (errors.email || errors.send_on);
            const text = typeof json.description === 'string' ? json.description : null;
            if (!fieldErrors) this.showError('form', text || this.dataset.errorGeneric);
            return;
          }
          window.location.href = this.dataset.cartUrl;
        } catch (err) {
          this.showError('form', this.dataset.errorGeneric);
        } finally {
          this.el.submit.setAttribute('aria-busy', 'false');
          this.el.submit.querySelector('.loading__spinner')?.classList.add('hidden');
        }
      }
    }
  );
}
